import React, { useState, useEffect } from "react";
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import { Add, Remove, Info } from "@mui/icons-material";
// fetch("https://wordle.talele.co.in").then().catch((err)=>console.log(err))

const App = () => {
  
  const [open, setOpen] = useState(false);
  const [openData, setOpenData] = useState(false);
  const [openGames, setOpenGames] = useState(false);
  const [openPortfolio, setOpenPortfolio] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setOpen(true);
    }, 500); // 5000 milliseconds = 5 seconds

    return () => clearTimeout(timer);
  }, []);

  const handleClick = () => {
    setOpen(!open);
  };

  const handleDataClick = () => {
    setOpenData(!openData);
  };

  const handleGamesClick = () => {
    setOpenGames(!openGames);
  };

  const handlePortfolioClick = () => {
    setOpenPortfolio(!openPortfolio);
  };

  const handleLinkClick = (url) => {
    window.location.href = url;
  };

  return (
    
    <div>
      <div
        style={{
          position: "absolute", // Ensures it stays at the screen corner
          top: "10px",
          left: "10px",
          cursor: "pointer",
          zIndex: 1000, // Ensures it appears above other elements
        }}
        onClick={() => alert(
`website by Soham Talele
last updated: 25 Sept 2025`)}
      >
        <Info style={{ fontSize: "2rem" }} />
      </div>
      <div
      style={{
        textAlign: "center",
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "400px",
        lineHeight: 0,
        fontFamily: "Syne",
      }}
    >
      <Typography
        variant="h1"
        onClick={handleClick}
        style={{ cursor: "pointer", fontFamily: "Syne", font:"Syne-Bold" }}
      >
        talele
      </Typography>
      <Collapse in={open} timeout={500} unmountOnExit>
        <List component="div" disablePadding>
          <ListItemButton onClick={handleDataClick}>
            <ListItemText primary="data" />
            {openData ? <Remove /> : <Add />}
          </ListItemButton>
          <Collapse in={openData} timeout="auto" unmountOnExit>
            <List component="div" disablePadding style={{ paddingLeft: "2rem",fontFamily: "Penlike", font:"Penlike"  }}>
              {DATA.map((item, index) => (
                <ListItemButton
                  key={index}
                  onClick={() => handleLinkClick(item.url)}
                >
                  <ListItemText
                    primary={item.name}
                    secondary={item.url}
                    style={{ fontSize: "1.5rem" }}
                  />
                </ListItemButton>
              ))}
            </List>
          </Collapse>
          <ListItemButton onClick={handleGamesClick}>
            <ListItemText primary="games" />
            {openGames ? <Remove /> : <Add />}
          </ListItemButton>
          <Collapse in={openGames} timeout="auto" unmountOnExit>
            <List component="div" disablePadding style={{ paddingLeft: "2rem" }}>
              {GAMES.map((item, index) => (
                <ListItemButton
                  key={index}
                  onClick={() => handleLinkClick(item.url)}
                >
                  <ListItemText
                    primary={item.name}
                    secondary={item.url}
                    style={{ fontSize: "1.5rem" }}
                  />
                </ListItemButton>
              ))}
            </List>
          </Collapse>
          <ListItemButton onClick={handlePortfolioClick}>
            <ListItemText primary="portfolio" />
            {openPortfolio ? <Remove /> : <Add />}
          </ListItemButton>
          <Collapse in={openPortfolio} timeout="auto" unmountOnExit>
            <List component="div" disablePadding style={{ paddingLeft: "2rem" }}>
              {PORTFOLIO.map((item, index) => (
                <ListItemButton
                  key={index}
                  onClick={() => handleLinkClick(item.url)}
                >
                  <ListItemText
                    primary={item.name}
                    secondary={item.url}
                    style={{ fontSize: "1.5rem" }}
                  />
                </ListItemButton>
              ))}
            </List>
          </Collapse>
        </List>
      </Collapse>
    </div>

    </div>
  );
};

const DATA = [
  { name: "WikiClouds", url: "https://wiki.talele.co.in" },
  { name: "Colour Map", url: "https://map.talele.co.in" },
  { name: "TV Analyzer", url: "https://tva.talele.co.in" },
];

const GAMES = [
  { name: "wordle (takes a minute to start up server)", url: "https://wordle.talele.co.in" },
  { name: "numbers go up! (work in progress)", url:'https://ngu.talele.co.in'}
];

const PORTFOLIO = [
  { name: "thelighterclub", url: "https://tlc.talele.co.in" },
  { name: "rg", url: "https://rg.talele.co.in" },
];

export default App;
